import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideoFileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"video_file"}/>
}
